/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Bidding_N_Battles__Answer_6Inputs */

const en_help_center__bidding_n_battles__answer_6 = /** @type {((inputs: Help_Center__Bidding_N_Battles__Answer_6Inputs) => LocalizedString) & { parts: (inputs: Help_Center__Bidding_N_Battles__Answer_6Inputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Bidding_N_Battles__Answer_6Inputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Early Game: Use +5s bids to extend time and conserve budgetMid Game: Mix +3s and +5s to stay competitiveEnd Game (under 10s): Use +0s bids for instant wins without giving opponents timeMonitor opponent patterns, time your bids strategically, and save some bids for the final moments!`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Bidding_N_Battles__Answer_6Inputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Early Game: Use +5s bids to extend time and conserve budget" }, { type: "markup-standalone", name: "br", options: {}, attributes: {} }, { type: "text", value: "Mid Game: Mix +3s and +5s to stay competitive" }, { type: "markup-standalone", name: "br", options: {}, attributes: {} }, { type: "text", value: "End Game (under 10s): Use +0s bids for instant wins without giving opponents time" }, { type: "markup-standalone", name: "br", options: {}, attributes: {} }, { type: "text", value: "Monitor opponent patterns, time your bids strategically, and save some bids for the final moments!" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Early Game: Use +5s bids to extend time and conserve budgetMid Game: Mix +3s and +5s to stay competitiveEnd Game (under 10s): Use +0s bids for instant wins w..." |
*
* @param {Help_Center__Bidding_N_Battles__Answer_6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__bidding_n_battles__answer_6 = /** @type {((inputs?: Help_Center__Bidding_N_Battles__Answer_6Inputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Bidding_N_Battles__Answer_6Inputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Bidding_N_Battles__Answer_6Inputs, { locale?: "en" }, { br: { options: {}; attributes: {}; children: false } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Bidding_N_Battles__Answer_6Inputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__bidding_n_battles__answer_6(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Bidding_N_Battles__Answer_6Inputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__bidding_n_battles__answer_6.parts === "function" ? en_help_center__bidding_n_battles__answer_6.parts(inputs) : [{ type: "text", value: en_help_center__bidding_n_battles__answer_6(inputs) }]
			})
		}
	)
);